import { render } from "./ZonasList.vue?vue&type=template&id=6de6c5ea&scoped=true"
import script from "./ZonasList.vue?vue&type=script&lang=js"
export * from "./ZonasList.vue?vue&type=script&lang=js"

import "./ZonasList.vue?vue&type=style&index=0&id=6de6c5ea&scoped=true&lang=css"

import exportComponent from "/home/runner/work/system-jj-frontend/system-jj-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6de6c5ea"]])

export default __exports__